import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

import { ValidationTrack } from '../pages/ValidationPageV2/types';

interface ValidationV2State {
  track: ValidationTrack | null;
  companyId: number | null;
  crawlResultId: number | null;
  userId: number | null;
  authId: string | null;
  lockAcquired: boolean;
  companyValidated: boolean;
  isSoftware: string | null;
}

interface ValidationV2ContextType {
  state: ValidationV2State;
  setState: Dispatch<SetStateAction<ValidationV2State>>;
}

const initialState: ValidationV2State = {
  track: null,
  companyId: null,
  crawlResultId: null,
  userId: null,
  authId: null,
  lockAcquired: false,
  companyValidated: false,
  isSoftware: null,
};

const ValidationV2Context = createContext({} as ValidationV2ContextType);

export const ValidationV2Provider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, setState] = useState<ValidationV2State>(initialState);

  return <ValidationV2Context.Provider value={{ state, setState }}>{children}</ValidationV2Context.Provider>;
};

export const useValidationV2 = (): ValidationV2ContextType => {
  const context = useContext(ValidationV2Context);
  if (!context) {
    throw new Error('useValidationV2 must be used within a ValidationV2Provider');
  }
  return context;
};
